var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.layoutData.enable_na || _vm.layoutData.label != null
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-md-5 col-sm-5 col-xs-5 text-right",
                staticStyle: {
                  "font-weight": "bold",
                  "padding-right": "0",
                  "padding-left": "0",
                  "margin-top": "5px",
                  "text-decoration": "underline"
                }
              },
              [_vm._v(_vm._s(_vm.layoutData.label))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-md-7 col-sm-7 col-xs-7 d-flex",
                class:
                  _vm.layoutData.none_allowed === true
                    ? "text-left"
                    : "text-right",
                style: { "justify-content": "space-between" }
              },
              [
                _vm.layoutData.none_allowed === true &&
                _vm.layoutData.valueGroups.length == 0
                  ? _c(
                      "button",
                      {
                        staticClass: "btn green-jungle",
                        on: { click: _vm.addClick }
                      },
                      [_c("i", { staticClass: "fa fa-plus" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.layoutData.enable_difference
                  ? _c(
                      "button",
                      {
                        staticClass: "btn orange",
                        on: { click: _vm.calculateDifference }
                      },
                      [_vm._v("Différence")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.layoutData.enable_na
                  ? _c(
                      "button",
                      {
                        staticClass: "btn",
                        class: _vm.layoutData.na_value
                          ? "btn-danger"
                          : "btn-default",
                        on: { click: _vm.naToggle }
                      },
                      [_vm._v("N/A")]
                    )
                  : _vm._e()
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.layoutData.valueGroups, function(valueGroup, index2) {
        return _c(
          "div",
          _vm._l(_vm.enabledFields, function(field, index) {
            return _c("timesheet-field", {
              key: index,
              attrs: {
                layout: field,
                value: valueGroup[field.name],
                errors:
                  _vm.layoutData.errors[index2] == undefined ||
                  _vm.layoutData.errors[index2][field.name] == undefined
                    ? []
                    : _vm.layoutData.errors[index2][field.name],
                index: index2,
                showAddButton: index == 0 && index2 == 0,
                showRemoveButton:
                  (index == 0 && index2 != 0) ||
                  (index == 0 && _vm.layoutData.none_allowed === true)
              },
              on: {
                change: _vm.onActivityChange,
                addClick: _vm.addClick,
                removeClick: _vm.removeClick
              }
            })
          }),
          1
        )
      }),
      _vm._v(" "),
      _vm.layoutData.has_total_duration === true
        ? [
            _c("timesheet-field", {
              attrs: {
                layout: _vm.durationTotalLayout,
                value: _vm.durationTotalLayout.value
              },
              on: { change: _vm.onChange }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.layoutData.errorText != null
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-5" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-7 is-invalid" }, [
              _vm._v("\n      " + _vm._s(_vm.layoutData.errorText) + "\n    ")
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }